import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'PAYMENT',
    icon: 'menu-payment',
    label: '付款和开票',
    children: [
      {
        code: 'PAYMENT_APPLICATION',
        icon: 'menu-payment-daily',
        label: '付款申请',
        path: '/payment/application',
      },
      {
        code: 'PAYMENT_RECEIPT_APPLICATION',
        icon: 'menu-payment-warehouse',
        label: '收款申请',
        path: '/payment/receipt-application',
      },
      {
        code: 'PAYMENT_REFUND_APPLICATION',
        icon: 'menu-payment-logistics',
        label: '退款申请',
        path: '/payment/refund-application',
      },
      {
        code: 'PAYMENT_EXPENSE_OFFSET',
        icon: 'menu-payment-document-fee',
        label: '费用冲抵',
        path: '/payment/expense-offset',
      },
      {
        code: 'PAYMENT_CURRENT_ACCOUNT',
        icon: 'menu-payment-current-account',
        label: '往来款',
        path: '/payment/current-account',
      },
      {
        code: 'PAYMENT_INVOICE_APPLICATION',
        icon: 'menu-invoice-application',
        label: '开票申请',
        path: '/payment/invoice-application',
      },
    ],
  },
] satisfies Menu[];
